<template>
  <div>
    <!-- Hero Section -->
    <section class="py-20 bg-gradient-dark">
      <div class="container mx-auto px-6 text-center">
        <div class="flex items-center justify-center mb-6">
          <router-link to="/services" class="text-gold-400 hover:text-gold-300 transition-colors duration-300 mr-4">
            <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10 19l-7-7m0 0l7-7m-7 7h18" />
            </svg>
          </router-link>
          <h1 class="text-4xl md:text-6xl font-display font-bold text-gold-400">
            FIXED PROSTHETICS
          </h1>
        </div>
        <p class="text-xl text-gold-300 max-w-3xl mx-auto">
          Durable and precise fixed dental restorations for lasting oral health and function.
        </p>
      </div>
    </section>

    <!-- Products -->
    <section class="py-20">
      <div class="container mx-auto px-6">
        <!-- Crowns & Bridges -->
        <div class="mb-16">
          <div class="flex items-center mb-10">
            <div class="w-12 h-12 bg-gradient-gold rounded-full flex items-center justify-center mr-6">
              <span class="text-black-900 text-xl font-bold">1</span>
            </div>
            <h2 class="text-3xl md:text-4xl font-display font-bold text-gold-400">
              Crowns & Bridges
            </h2>
          </div>
          
          <div class="bg-black-800 rounded-2xl p-8 border border-gold-800 ml-0 md:ml-18">
            <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
              <div class="text-center p-6">
                <h3 class="text-2xl md:text-3xl font-display font-bold text-gold-400 mb-4">Multi-layer Zirconia</h3>
                <p class="text-gray-300 text-lg">Advanced zirconia with gradient translucency for natural aesthetics</p>
              </div>
              
              <div class="text-center p-6">
                <h3 class="text-2xl md:text-3xl font-display font-bold text-gold-400 mb-4">Full Contour Zirconia</h3>
                <p class="text-gray-300 text-lg">High-strength monolithic zirconia restorations</p>
              </div>
              
              <div class="text-center p-6">
                <h3 class="text-2xl md:text-3xl font-display font-bold text-gold-400 mb-4">E.MAX Crowns</h3>
                <p class="text-gray-300 text-lg">Lithium disilicate crowns with exceptional esthetics</p>
              </div>
              
              <div class="text-center p-6">
                <h3 class="text-2xl md:text-3xl font-display font-bold text-gold-400 mb-4">Porcelain Veneering</h3>
                <p class="text-gray-300 text-lg">High-quality porcelain layered on substructures</p>
              </div>
              
              <div class="text-center p-6">
                <h3 class="text-2xl md:text-3xl font-display font-bold text-gold-400 mb-4">Porcelain Fused to Metal (PFM)</h3>
                <p class="text-gray-300 text-lg">Traditional restorations with proven reliability</p>
              </div>
            </div>
          </div>
        </div>

        <!-- Full Metal Crowns -->
        <div class="mb-16">
          <div class="flex items-center mb-10">
            <div class="w-12 h-12 bg-gradient-gold rounded-full flex items-center justify-center mr-6">
              <span class="text-black-900 text-xl font-bold">2</span>
            </div>
            <h2 class="text-3xl md:text-4xl font-display font-bold text-gold-400">
              Full Metal Crowns
            </h2>
          </div>
          
          <div class="bg-black-800 rounded-2xl p-8 border border-gold-800 ml-0 md:ml-18">
            <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
              <div class="text-center p-6">
                <h3 class="text-2xl md:text-3xl font-display font-bold text-gold-400 mb-4">Precious/Semi Precious</h3>
                <p class="text-gray-300 text-lg">High-quality precious metal alloys for superior restorations</p>
              </div>
              
              <div class="text-center p-6">
                <h3 class="text-2xl md:text-3xl font-display font-bold text-gold-400 mb-4">Base Metal Alloy</h3>
                <p class="text-gray-300 text-lg">Durable and cost-effective metal crown solutions</p>
              </div>
              
              <div class="text-center p-6">
                <h3 class="text-2xl md:text-3xl font-display font-bold text-gold-400 mb-4">Post & Core</h3>
                <p class="text-gray-300 text-lg">Foundation restorations for endodontically treated teeth</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Back to Services -->
    <section class="py-20">
      <div class="container mx-auto px-6 text-center">
        <router-link to="/services" class="btn-secondary inline-flex items-center text-lg py-4 px-8">
          <svg class="w-6 h-6 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10 19l-7-7m0 0l7-7m-7 7h18" />
          </svg>
          Back to All Services
        </router-link>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'FixedServices'
}
</script>